import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import Router from '../src/Components/Routes/Routes'; // Import the router
import 'bootstrap/dist/css/bootstrap.min.css';
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the RouterProvider with the router that includes protected routes
root.render(
  // <React.StrictMode>
  <RouterProvider router={Router} />
  // </React.StrictMode>
);

reportWebVitals();
